export function isAdminEmail(email?: string | null) {
	return email?.trim().toLowerCase() === 'chrismoorst@gmail.com'
}
